import { createSlice } from '@reduxjs/toolkit';

export const cookieDetailsSlice = createSlice({
  name: 'cookieDetails',
  initialState: {
    cookieValue: undefined,
    hasCookies: undefined
  },
  reducers: {
    setCookieDetails: (state, action) => {
      const { cookieValue, hasCookies } = action.payload;
      state.cookieValue = cookieValue;
      state.hasCookies = hasCookies;
    },
  },
});

export const { setCookieDetails } = cookieDetailsSlice.actions;
export default cookieDetailsSlice.reducer;